import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiledataApi } from "../services/akfenservicesprod/api";
import { Line } from "react-chartjs-2";

function RentalIncome() {
  //#region Api
  const fileDataProdApi = new FiledataApi({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = fileDataProdApi;
  //#endregion

  //#region Page Property
  const { t, i18n } = useTranslation();
  const chartRef = useRef();
  //#endregion

  //#region useState
  const [selectedLang, setSelectedLang] = useState("");
  const [data, setData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
        label: "tst",
      },
    ],
  });

  const chartOptions = {
     maintainAspectRatio: false,
  responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: (context) => {
            const datasetLabel = context.dataset.label || "";
            return (
              datasetLabel +
              ": " +
              number_format(Number(context.parsed.y), 0, ".", ",")
            );
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#000",
          font: {
            size: 13,
          },
          precision: 0,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#E1E2E2",
        },
        title: {
          display: true,
          text: t("Thousand"),
        },
        ticks: {
          beginAtZero: true,
          color: "#000",
          font: {
            size: 12,
          },
          padding: 15,
          callback: (value) => {
            const numValue = Number(value);
            if (numValue >= 1000) {
              return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return numValue;
          },
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  const number_format = (number, decimals, dec_point, thousands_sep) => {
    number = (number + "").replace(",", "").replace(" ", "");
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = thousands_sep ?? ",";
    const dec = dec_point ?? ".";
    const toFixedFix = (n, prec) => {
      const k = Math.pow(10, prec);
      return "" + Math.round(n * k) / k;
    };

    let s = [];
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  };
  //#endregion

  //#region Data
  const pageData = () => {
    if (api !== undefined && api !== "") {
      api.apiFiledataPerformanceGet().then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          let otherChartData = datas["otherChart"];
          otherChartData = otherChartData.map((item) => {
            return parseFloat(item) / 1000;
          });
          let labels = datas["HeaderOtherChart"];
          const newChartData = {
            labels: labels,
            datasets: [
              {
                data: otherChartData,
                fill: false,
                borderColor: "#CC2D41",
                backgroundColor: ["#CC2D41"],
                borderWidth: 1,
                pointRadius: 0,
                label: t("RentlncomeText"),
              },
            ],
          };
          setData(newChartData);
        }
      });
    }
  };
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (window.location.pathname.indexOf("rentalincome") !== -1) {
        i18n.changeLanguage("en");
      setSelectedLang("en-US");
    } else {
        i18n.changeLanguage("tr");
      setSelectedLang("tr-TR");
    }
  }, []);

  useEffect(() => {
    if (selectedLang !== "") pageData();
  }, [selectedLang]);
  //#endregion

  return (
    <div className="rentalIncome">
      <div className="row mb-3">
        <div className="col-md-12">
          <div className="pageArea d-inline-block position-relative w-100 ">
            <div className="item">
              <div className="chart_title text-center">
                <span className="d-inline-block position-relative pb-2">
                  {t("RentalIncomeHeader")}
                </span>
              </div>

              <div
                style={{ width: "100%", height: "298px" }}
                className=" d-block"
              >
                <Line
                  className="mb-5"
                  ref={chartRef}
                  data={data}
                  options={chartOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RentalIncome;
